import { render } from "./confirmOTP.vue?vue&type=template&id=c7c3d980"
import script from "./confirmOTP.vue?vue&type=script&lang=js"
export * from "./confirmOTP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__